module.exports = __webpack_public_path__ + "static/media/wtr-logo-wide.7b644623.png";